export default "__VITE_ASSET__Ba_rDJWN__"